import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	publishButton: {
		id: 'jpd-publish-feature-discovery.publish-button',
		defaultMessage: 'Publish',
		description: 'Publish dialog button label when not published and user is on the free edition',
	},
});
